var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerPin01 = function SvgMarkerPin01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.278 11.336q.53-.531.53-1.278 0-.748-.53-1.278A1.74 1.74 0 0 0 12 8.25q-.747 0-1.278.53-.53.53-.53 1.278 0 .747.53 1.277.531.53 1.278.53.749 0 1.278-.53M12 19.514q2.936-2.628 4.491-5.04 1.557-2.412 1.557-4.226 0-2.735-1.737-4.496T12 3.991 7.69 5.752t-1.738 4.496q0 1.814 1.557 4.226T12 19.514m0 1.995q-3.776-3.27-5.661-6.088-1.887-2.817-1.887-5.173 0-3.462 2.24-5.605Q8.93 2.5 12 2.5t5.309 2.143q2.24 2.144 2.24 5.605 0 2.356-1.887 5.173T12 21.51"
  })));
};
export default SvgMarkerPin01;